import { ContextService } from '../../../services/context_service';
import { lazyInject } from '../../../services/inversify';
import { KennzahlenAggregation } from './KennzahlenAggregation';
import { KennzahlenDefinition } from './KennzahlenDefinition';
import { KennzahlenImport } from './KennzahlenImport';
import { KennzahlenImportETool } from './KennzahlenImportETool';
import { KennzahlenRoh } from './KennzahlenRoh';
import { KennzahlenRohExport } from './KennzahlenRohExport';
import * as React from 'react';
import { Routing } from '../../../helpers/Routing';
import { RoutingIDs } from '../../../helpers/RoutingAdminIDs';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import '../../../css/tabs.css';

interface KennzahlenDatenbankProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
}

interface KennzahlenDatenbankState {
    tabIndex: number;
}

export class KennzahlenDatenbank extends React.Component<KennzahlenDatenbankProps, KennzahlenDatenbankState> {

    constructor(props: any) {
        super(props);
        this.state = {
            tabIndex: null
        };
    }

    @lazyInject(ContextService) private contextService: ContextService;

    private disabled: string[] = [];
    private prefix: string = 'admin.tab.kennzahlen_datenbank';
    private rechte: any = {};
    private tabName: string = RoutingIDs.TABS_KENNZAHLEN_DATENBANK;
    private tabIndex: string = `${this.tabName}Index`;
    private tabRoutings: any[] = [
        { path: RoutingIDs.ROUTE_KENNZAHLEN_DATENBANK_KENNZAHLEN_DEFINITION },
        { path: RoutingIDs.ROUTE_KENNZAHLEN_DATENBANK_IMPORT_INITIAL },
        { path: RoutingIDs.ROUTE_KENNZAHLEN_DATENBANK_IMPORT_E_TOOL },
        { path: RoutingIDs.ROUTE_KENNZAHLEN_DATENBANK_DATEN_ROH },
        { path: RoutingIDs.ROUTE_KENNZAHLEN_DATENBANK_DATEN_AGGREGIERT },
        { path: RoutingIDs.ROUTE_KENNZAHLEN_DATENBANK_DATENBANK_EXPORT }
    ];
    private tabs: string[] = [ // Reitereihenfolge beachten
        'kennzahlen', 'import.initial', 'import.etool', 'daten.roh', 'daten.aggregiert', 'datenbank.export'
    ];

    componentDidMount(): void {
        (new Routing(this)).init((rechte: any, tabIndex: number) => {
            this.rechte = rechte || {};
            this.setTabIndex(tabIndex, this.tabRoutings[tabIndex]);
        });
    }

    componentDidUpdate(prevProps: any): void {
        if (JSON.stringify(this.props.routing) !== JSON.stringify(prevProps.routing)) {
            this.checkRouting();
        }
    }

    checkRouting(): void {
        const routing: any = this.props.routing || {};
        if (typeof (routing.path || {})[this.tabName] === 'undefined') {
            return;
        }
        // this.setTabIndex(routing.path[this.tabName], routing, () => {
        //     if (routing.path.terminateOn === this.tabName) {
        //         this.props.onRoutingChange({});
        //     }
        // });
        if (this.state.tabIndex === routing.path[this.tabName]) {
            if (routing.path.terminateOn === this.tabName) {
                this.props.onRoutingChange({});
            }
        } else {
            this.setTabIndex(routing.path[this.tabName], routing);
        }
    }

    render(): JSX.Element {
        if (this.state.tabIndex === null) {
            return null;
        }

        return (
            <Tabs
                className='tabs-admin-kennzahlen_datenbank'
                selectedIndex={this.state.tabIndex}
                onSelect={(tabIndex, lastIndex, event) => this.setTabIndex(tabIndex, this.tabRoutings[tabIndex])}
            >
                <TabList>
                    <Tab disabled={!this.rechte.kennzahlen}>Kennzahlen (Definition)</Tab>
                    <Tab disabled={!this.rechte['import.initial']}>Import (Initial)</Tab>
                    <Tab disabled={!this.rechte['import.etool']}>Import (E-Tool)</Tab>
                    <Tab disabled={!this.rechte['daten.roh']}>Daten - Roh</Tab>
                    <Tab disabled={!this.rechte['daten.aggregiert']}>Daten - Aggregiert</Tab>
                    <Tab disabled={!this.rechte['datenbank.export']}>Datenbank - Export</Tab>
                </TabList>
                <TabPanel>
                    {this.rechte.kennzahlen &&
                        <KennzahlenDefinition />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte['import.initial'] &&
                        <KennzahlenImport
                            data={this.props.data}
                        />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte['import.etool'] &&
                        <KennzahlenImportETool
                            data={this.props.data}
                        />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte['daten.roh'] &&
                        <KennzahlenRoh />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte['daten.aggregiert'] &&
                        <KennzahlenAggregation
                            data={this.props.data}
                        />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte['datenbank.export'] &&
                        <KennzahlenRohExport
                            data={this.props.data}
                        />
                    }
                </TabPanel>
            </Tabs>
        );
    }

    setTabIndex(tabIndex: number, tabRouting: any, callback?: () => void): void {
        if (this.state.tabIndex !== tabIndex) {
            setTimeout(() => {
                this.setState({ tabIndex }, () => {
                    this.props.onRoutingChange(tabRouting);
                    this.contextService.set(this.tabIndex, tabIndex);

                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            });
        }
    }
}
